import { FC, useState } from "react";

import { BestPracticeSvgLogo, Stack, Text } from "@bps/fluent-ui";
import { Form } from "@bps/form-api";

import { ErrorResult } from "../../api/base";
import { pinFields } from "./VerifyPinForm.constants";
import { VerifyPinFormValues } from "./VerifyPinForm.interface";
import { VerifyPinFormError } from "./VerifyPinFormError";
import { VerifyPinFormFields } from "./VerifyPinFormFields";

type VerifyPinFormProps = {
  submitPin: (pin: string) => Promise<void>;
};

// This component is a simplified version of the component from Bps.Platform.BpId.WebApp

export const VerifyPinForm: FC<VerifyPinFormProps> = ({ submitPin }) => {
  const [attempts, setAttempts] = useState(1);
  const [error, setError] = useState<ErrorResult>();

  const initialValues: VerifyPinFormValues = {
    a: "",
    b: "",
    c: "",
    d: "",
    e: "",
    f: ""
  };

  const validate = (values: VerifyPinFormValues) => {
    const result: Record<string, string> = {};
    pinFields.forEach(key => {
      if (!values[key]) {
        result[key] = "Required";
      }
    });

    return result;
  };

  const onSubmit = ({ a, b, c, d, e, f }: VerifyPinFormValues) => {
    return submitPin([a, b, c, d, e, f].join("")).catch(error => {
      setError(error);
      setAttempts(value => value + 1);
    });
  };

  const MAX_WIDTH = 340;

  return (
    <Stack horizontalAlign="center" verticalAlign="center" verticalFill grow>
      <Stack
        tokens={{ childrenGap: 24 }}
        styles={{ root: { maxWidth: MAX_WIDTH } }}
      >
        <Stack tokens={{ childrenGap: 8 }}>
          <BestPracticeSvgLogo isBlue width={MAX_WIDTH} />
          <Text variant="xLarge" styles={{ root: { textAlign: "center" } }}>
            Verify your identity
          </Text>
          <Text styles={{ root: { textAlign: "center" } }}>
            Enter your date of birth to confirm your identity and ensure this
            message is intended for you
          </Text>
          <VerifyPinFormError error={error} attempts={attempts} />
        </Stack>
        <Form.Provider<VerifyPinFormValues>
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {() => <VerifyPinFormFields error={error} />}
        </Form.Provider>
      </Stack>
    </Stack>
  );
};
